import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';

import { User, ErrCode, BlendEvent } from '../../shared/models';
import { LoggerService } from '../../core/logger.service';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ResetPasswordService } from '../../core/resetpassword.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PasswordService } from '../services/password.service';
import { BlendService } from 'src/app/shared/services/blend.service';

@Component({
    selector: 'sync-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css'],
    providers: [ResetPasswordService]
})
export class ResetPasswordComponent implements OnInit {

    public confirmcode: string;
    public user: User;
    public errcode: ErrCode;
    public spinner = true;
    public isInviteChecked = false;
    public authenticated: boolean;
    public resetPasswordForm: FormGroup;

    constructor(
        private log: LoggerService,
        private store: Store<fromRoot.State>,
        private fb: FormBuilder,
        private rsService: ResetPasswordService,
        private router: Router,
        private route: ActivatedRoute,
        private pwdService: PasswordService,
        private blendService: BlendService
    ) { }

    ngOnInit() {
        this.errcode = undefined;
        this.resetPasswordForm = this.fb.group({
            password: ['', Validators.required],
            confirmPassword: ['', Validators.required],
        });
        this.store
            .select(fromRoot.getAuthState)
            .subscribe((data) => {
                this.authenticated = data.authenticated;
                if (!data.authenticated) {
                    this.user = new User();
                    return;
                }
                if (data.user) {
                    this.user = data.user;
                }
            });
        this.confirmcode = this.route.snapshot.queryParams['c'];
        if (this.confirmcode) {
            this.verifyEmailInvite();
        } else {
            this.errcode = new ErrCode(8103, 'No confirmation code provided');
        }
    }

    public async verifyEmailInvite() {
        try {
            const result = await this.rsService.verifyEmailInvite(this.confirmcode);
            if (result.error_code) {
                this.errcode = new ErrCode(result.error_code);
            } else {
                console.log(result);
                this.isInviteChecked = true;
            }
        } catch (ex) {
            this.log.error(ex);
            this.errcode = ErrCode.fromException(ex);
        }
        this.spinner = false;
    }

    public async resetPasswordSubmit() {
        this.errcode = undefined;
        this.spinner = true;
        const pwd = this.resetPasswordForm.get('password').value;
        const cpwd = this.resetPasswordForm.get('confirmPassword').value;
        if (pwd && !this.pwdService.isPasswordStrong(pwd)) {
            this.errcode = new ErrCode(8304);
            this.spinner = false;
            return;
        }
        if (pwd !== cpwd) {
            this.errcode = new ErrCode(8121, 'Your passwords do not match');
            this.spinner = false;
            return;
        }
        try {
            const result = await this.rsService.resetPasswordSubmit(this.confirmcode, pwd);
            if (this.authenticated && this.user.id == result['user_id']) {
                const newState = (this.user.has_gettingstarted)
                    ? '/files'
                    : '/account/getstarted';
                this.router.navigate([newState], { queryParams : undefined });
            } else {
                this.router.navigate(['/login'], { queryParams : { passwordset: 1 } });
            }
        } catch (ex) {
            this.log.error(ex);
            this.errcode = ErrCode.fromException(ex);
        }
        this.spinner = false;
    }

    private checkPasswords: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
        const pass = group.get('password').value;
        const confirmPass = group.get('confirmPassword').value;
        return pass === confirmPass ? null : { notSame: true };
    }
}
